import { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  Col,
  Dropdown,
  DropdownButton,
  Form,
  Row,
} from "react-bootstrap";
import articleImg1 from "../assets/images/article-01.jpg";
import articleImg2 from "../assets/images/article-02.jpg";
import { Link } from "react-router-dom";
import { RxBookmark } from "react-icons/rx";
import { TbArrowsSort, TbAdjustmentsHorizontal } from "react-icons/tb";
import { BsImage } from "react-icons/bs";

export default function Reports() {
  const items = [
    {
      id: 1,
      title:
        "Learning the natural history of human disease with generative transformers",
      image: articleImg1,
      PMID: 20878177,
      trial: "Clinical Trial",
      type: ["Wang Q", "Xiao ZX", "Zheng X", "Xiang N", "Schett G"],
      paid: false,
    },
    {
      id: 2,
      title:
        "Drug resistance in idiopathic generalized epilepsies: Evidence and concepts",
      image: articleImg2,
      PMID: 308255177,
      trial: "Clinical Trial",
      type: ["Wang Q", "Xiao ZX", "Zheng X", "Xiang N", "Schett G"],
      paid: true,
    },
    {
      id: 3,
      title:
        "Orforglipron, an Oral Small-Molecule GLP-1 Receptor Agonist for Obesity Treatment.",
      image: articleImg1,
      PMID: 25484544,
      trial: "Clinical Trial",
      type: ["Wang Q", "Xiao ZX", "Zheng X", "Xiang N", "Schett G"],
      paid: true,
    },
    {
      id: 4,
      title:
        "In Vivo CD19 CAR T-Cell Therapy for Refractory Systemic Lupus Erythematosus",
      image: null,
      PMID: 208781548,
      trial: "Clinical Trial",
      type: ["Wang Q", "Xiao ZX", "Zheng X", "Xiang N", "Schett G"],
      paid: false,
    },
  ];
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [reports, setReports] = useState(items);
  const [article, setArticle] = useState(items);

  return (
    <>
      <Row className="mb-sm-3 align-items-center">
        <Col md={6}>
          <h2 className="mb-md-0">Saved Report</h2>
        </Col>
        <Col md={6} className="mb-4 mb-md-0">
          <div className="d-flex flex-wrap align-items-center justify-content-md-end">
            <DropdownButton
              title={
                <>
                  Sort by <TbArrowsSort />
                </>
              }
              align="end"
              autoClose="outside"
            >
              <Dropdown.Header>SORT BY</Dropdown.Header>
              <Dropdown.Divider />
              <div className="filter-list">
                <Form.Check
                  label="Free reports"
                  type="radio"
                  name="reportRadio"
                />
                <Form.Check
                  label="Paid reports"
                  type="radio"
                  name="reportRadio"
                />
              </div>
            </DropdownButton>
            <DropdownButton
              title={
                <>
                  Filter by <TbAdjustmentsHorizontal />
                </>
              }
              align="end"
              className="ms-2"
              autoClose="outside"
            >
              <Dropdown.Header>FILTER BY</Dropdown.Header>
              <Dropdown.Divider />
              <div className="filter-list">
                <Form.Check label="Most Recent" />
                <Form.Check label="A to Z" />
                <Form.Check label="Z to A" />
              </div>
            </DropdownButton>
          </div>
        </Col>
      </Row>

      <div className="profile-content profile-content-report">
        <Row className="g-2">
          {article.map((item) => (
            <Col sm={12} lg={6} key={item.id}>
              <Link to="#">
                <Card className="article-card save-article-card">
                  <Row>
                    <Col xs={12} md={2} className="pe-md-0 mb-4 mb-md-0">
                      <Card.Header className="p-0 bg-transparent border-bottom-0 ratio ratio-1x1">
                        {item?.image !== null ? (
                          <img src={item?.image} alt="" />
                        ) : (
                          <div className="image-placeholder">
                            <BsImage />
                          </div>
                        )}
                      </Card.Header>
                    </Col>
                    <Col xs={10} md={9}>
                      <Card.Body className="p-0">
                        <Card.Title className="mt-0">{item?.title}</Card.Title>
                        <div className="tag-list">
                          {item?.type?.map((tag, index) => (
                            <Badge key={index} className="tag">
                              {tag}
                            </Badge>
                          ))}
                        </div>
                        <p className="pmid">PMID: {item?.PMID}</p>
                        <p className="trial">{item?.trial}</p>
                      </Card.Body>
                      <Card.Footer className="p-0 bg-transparent border-top-0">
                        <Button variant="outline-secondary">READ MORE</Button>
                      </Card.Footer>
                    </Col>
                    <Col xs={2} md={1} className="text-end">
                      <Button className="save-btn">
                        <RxBookmark />
                      </Button>
                    </Col>
                  </Row>
                  {item?.paid === true && (
                    <div className="paid-card-overlay">
                      <Button variant="outline-secondary">Buy Report</Button>
                    </div>
                  )}
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
}
